/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_PropInputs */

const en_cl_prop = /** @type {(inputs: Cl_PropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content language`)
};

const de_cl_prop = /** @type {(inputs: Cl_PropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltssprache`)
};

/**
* | output |
* | --- |
* | "Content language" |
*
* @param {Cl_PropInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_prop = /** @type {((inputs?: Cl_PropInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_PropInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_prop(inputs)
	return en_cl_prop(inputs)
});